const COBROWSEIO_KEY = "fVlVZkvjteEM4A";

export class Cobrowse {

  static install(userConfig) {
    const script = document.createElement('script');
    script.id = "cobrowseio";
    script.innerText = `
      (function(w,t,c,p,s,e){
          p=new Promise(function(r){w[c]={client:function(){return p}};
          s=document.createElement(t);s.async=1;s.src='https://js.cobrowse.io/CobrowseIO.js';
          e=document.getElementsByTagName(t)[0];e.parentNode.insertBefore(s,e);
          s.onload=function(){r(w[c]);};});return p;
      })(window,'script','CobrowseIO').then(function(){
          CobrowseIO.license = "${COBROWSEIO_KEY}";
          CobrowseIO.customData = {
            user_name: '${userConfig.name}',
            user_id: '${userConfig.identity}'
          };
          console.log('${userConfig.name}');
          CobrowseIO.start();
      });
    `

    script.addEventListener('load', () => {
    });

    document.body.appendChild(script);

  }

}
